import { AuthContext } from '@/modules/Auth/Auth.context';
import { DEFAULT_PERMISSIONS, UserPermission } from '@/modules/Permissions/Permissions.constants';
import { useCallback, useContext } from 'react';

export const usePermissions = () => {
  const { userGroups } = useContext(AuthContext)!;

  const hasPermission = useCallback(
    (permissions: UserPermission | UserPermission[]) => {
      return userGroups
        ? userGroups.some((group) => {
            const groupPermissions = DEFAULT_PERMISSIONS[group];

            if (!groupPermissions) {
              return false;
            }

            if (Array.isArray(permissions)) {
              return permissions.some((permission) => groupPermissions.includes(permission));
            }

            return groupPermissions.includes(permissions);
          })
        : false;
    },
    [userGroups]
  );

  return { hasPermission };
};
